<div class="grid-container padding-y-4">
  <form [formGroup]="oneTimeShipmentForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <legend class="usa-legend usa-legend--large">FRT One Time Only Shipment</legend>
        </div>
      </div>
      <div class="grid-row grid-gap-1">
        <!-- Shipment Details -->
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <div class="grid-row">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <legend class="usa-legend usa-legend--medium">Shipment Details</legend>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="pick_up_date">Pick-up Date</label>
              <input type="text" id="pick_up_date" class="maxw-full usa-input" formControlName="pickupDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="rate_quote">Rate Quote Amount<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr> <span class="font-sans-2xs">(Accessorials selected are
            included in the Rate Quote)</span> </label>
            <input type="text" id="rate_quote" class="usa-input maxw-full" appTwoDigitDecimalNumber (change) ="setTwoNumberDecimal()" formControlName="estimatedCost" [maxlength]="9">
            @if (this.oneTimeShipmentForm.get('estimatedCost').touched && this.oneTimeShipmentForm.get('estimatedCost').hasError('required')) {
              <div class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Rate Quote is required
              </div>
            }
            @if (this.oneTimeShipmentForm.get('estimatedCost').touched && this.oneTimeShipmentForm.get('estimatedCost').hasError('max')) {
              <div class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Max Rate quote amount allowed is 999999.99
              </div>
            }

          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="date_quote_received" class="usa-label">Date Quote Received<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr> </label>
            <input type="text" id="date_quote_received" class="usa-input maxw-full" formControlName="quoteDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label" for="ScacSearchString">SCAC<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" placeholder="Type a SCAC" id="ScacSearchString" class="usa-input maxw-full" formControlName='scacSearchString' (typeaheadOnSelect)="typeaheadScacOnSelect($event)" [typeaheadScrollable]="true" [typeahead]="scacCodeList" [typeaheadMinLength]="1"
              [typeaheadOptionsLimit]="10" [maxlength]="4">
            @if (isFormControlInValid('scac')) {
              <div class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>SCAC is required
              </div>
            }
          </div>
        </div>
      </div>
      <!-- SCACS -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <div class="grid-row">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">SCAC Details</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="scac_name" class="usa-label">SCAC Name</label>
            <input readonly type="text" id="scac_name" class="usa-input maxw-full" formControlName="scacName">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="scac_phone" class="usa-label">SCAC Phone<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="scac_phone" class="usa-input maxw-full" formControlName="scacPhone" [maxlength]="20" appNumbersOnly>
            @if (isFormControlInValid('scacPhone')) {
              <div>
                @if (oneTimeShipmentForm.get('scacPhone').hasError('minlength')) {
                  <div>
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Telephone must be 10 digits
                    </small>
                  </div>
                }
                @if (oneTimeShipmentForm.get('scacPhone').hasError('required')) {
                  <div>
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Telephone is required
                    </small>
                  </div>
                }
              </div>
            }
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="scac_email" class="usa-label">SCAC Email <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="scac_email" class="usa-input maxw-full" formControlName="scacEmail" [maxlength]="254">
            @if (isFormControlInValid('scacEmail')) {
              <div>
                @if (oneTimeShipmentForm.get('scacEmail').hasError('email')) {
                  <div>
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Enter a valid email
                    </small>
                  </div>
                }
                @if (oneTimeShipmentForm.get('scacEmail').hasError('required')) {
                  <div>
                    <small class="define-text-secondary">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                      </svg> Email is required
                    </small>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!-- Notes -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Comments</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="comments" class="usa-label">Comments : (Maximum 500 chars)</label>
            <textarea rows="5" id="comments" formControlName="comments" maxlength="500" class="maxw-full usa-textarea"></textarea>
          </div>
        </div>

      </div>
      <!-- Origin -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Origin</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label for="origin_country" class="usa-label">Country <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="origin_country" class="usa-select maxw-full" formControlName="originCountry" (change)="onOriginCountryChange()">
              <option [ngValue]="null">..Select a Destination Country..</option>
              @for (country of allCountries; track country) {
                <option [ngValue]="country">{{ country.stateCountryName }}
                </option>
              }
            </select>
            @if (oneTimeShipmentForm.get('originCountry').hasError('required')) {
              <div>
                <small class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Origin Country is required
                </small>
              </div>
            }
          </div>
          <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}} {{model.zipCode}} {{model.zipClassificationCode === 'P' ? 'P.O BOX ONLY' : ''}}</ng-template>
          @if (showOriginLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="origin" class="usa-label">Search Origin <abbr title="required"
              class="usa-hint usa-hint--required">*</abbr>:</label>
              <input id="origin" class="usa-input maxw-full" formControlName="asyncOriginSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)" (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
                typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
              @if (this.oneTimeShipmentForm.get('originZipId').touched && this.oneTimeShipmentForm.get('originZipId').hasError('required')) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Origin is required
                </div>
              }
            </div>
          }
          @if (showOriginLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="origin_city_name">City</label>
              <input type="text" readonly id="origin_city_name" class="usa-input maxw-full" formControlName="originCity" />
            </div>
          }
          @if (showOriginLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <div class="grid-row grid-gap-1">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="origin_state">State</label>
                  <input type="text" readonly id="origin_state" class="usa-input maxw-full" formControlName="originState" />
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="originZip">Zip Code</label>
                  <input type="text" readonly id="originZip" class="usa-input maxw-full" formControlName="originZipId" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Destination -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Destination</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label" for="destination_country">Country <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>

            <select id="destination_country" class="usa-select maxw-full" formControlName="destinationCountry" (change)="onDestinationCountryChange()">
              <option [ngValue]="null">..Select a Destination Country..</option>
              @for (country of allCountries; track country) {
                <option [ngValue]="country">{{ country.stateCountryName }}
                </option>
              }
            </select>
            @if (oneTimeShipmentForm.get('destinationCountry').hasError('required')) {
              <div>
                <small class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Destination Country is required
                </small>
              </div>
            }
          </div>
          @if (showDestinationLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="destination">Search Destination<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr> :</label>
              <input id="destination" class="usa-input maxw-full" formControlName="asyncDestinationSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceDestination" (typeaheadLoading)="changeTypeaheadDestinationLoading($event)" (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)"
                [typeaheadItemTemplate]="customItemTemplate" typeaheadOptionField="cityName" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
              @if (this.oneTimeShipmentForm.get('destinationZipId').touched && this.oneTimeShipmentForm.get('destinationZipId').hasError('required')) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Destination is required
                </div>
              }
            </div>
          }
          @if (showDestinationLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="origin_city_name" class="usa-label">City</label>
              <input type="text" readonly id="destination_city_name" class="usa-input maxw-full" formControlName="destinationCity" />
            </div>
          }
          @if (showDestinationLocation) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <div class="grid-gap-1 grid-row">
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="origin_state">State</label>
                  <input type="text" readonly id="destination_state" class="usa-input maxw-full" formControlName="destinationState" />
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="originZip">Zip Code</label>
                  <input type="text" readonly id="destinationZip" class="usa-input maxw-full" formControlName="destinationZipId" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Quote -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Quote</legend>
          </div>
          @if (showEstimatedMileage) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label class="usa-label" for="estimated_mileage">Estimated Mileage <abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" class="maxw-full usa-input" id="estimated_mileage" formControlName="estimatedMileage" name="mileage" appNumbersOnly>
              @if (this.oneTimeShipmentForm.get('estimatedMileage').touched && this.oneTimeShipmentForm.get('estimatedMileage').hasError('required')) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Estimated Mileage is required
                </div>
              }
            </div>
          }
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label" for="estimated_weight">Estimated Weight (lbs) <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" class="usa-input maxw-full" id="estimated_weight" formControlName="estimatedWeight" name="weight" appNumbersOnly>
            @if (this.oneTimeShipmentForm.get('estimatedWeight').touched && this.oneTimeShipmentForm.get('estimatedWeight').hasError('required')) {
              <div class="define-text-secondary">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Estimated Weight is required
              </div>
            }
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <label class="usa-label" for="tender_quote">Rate Quote #</label>
            <input type="text" id="tender_quote" class="usa-input maxw-full" formControlName="tenderQuote" [maxlength]="20">
          </div>
        </div>
      </div>
      <!-- Accesorials -->
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Accessorials</legend>
            <button type="button" class="usa-button" (click)="addAccessorial()">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
              </svg>  Accessorial
            </button>
          </div>
          @for (objs of oneTimeShipmentForm.get('accessorials')['controls']; track objs; let i = $index) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" formArrayName="accessorials">
              <ng-container [formGroupName]="i">
                <div class="grid-row grid-gap-1">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                    <label class="usa-label">Accessorials</label>
                    <select id="accessorial" formControlName="accessorial" class="usa-select maxw-full" (change)="onAccessorialChange($event, i)">
                      <option value='' selected disabled>Choose...</option>
                      @for (accessorial of accessorials; track accessorial) {
                        <option [ngValue]="accessorial">
                          {{ accessorial.accessorialCode }} - {{ accessorial.accessorialDescription }}
                        </option>
                      }
                    </select>
                  </div>
                  @if (this.oneTimeShipmentForm.get('accessorials')['controls'][i]['controls'].unitDescription.value !== null) {
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                      <label class="usa-label">{{this.oneTimeShipmentForm.get('accessorials')['controls'][i]['controls'].unitDescription.value}}</label>
                      <input type="text" id="units_1_{{i}}" formControlName="units" name="units" class="usa-input maxw-full">
                    </div>
                  }
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                    <button type="button" class="usa-button usa-button--secondary pin-bottom" (click)="removeAccessorial(i)">Delete</button>
                  </div>
                </div>
              </ng-container>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="padding-top-4">
      <button type="button" class="usa-button" (click)="submitShipment()" [disabled]="oneTimeShipmentForm.invalid">
        Submit
      </button>
      <button type="button" class="usa-button usa-button--secondary magin-left-2" (click)="resetForm()">
        Reset
      </button>
    </div>
  </fieldset>
</form>
</div>
